export default {
	name: "Breadcrumbs",
	props: {
		items: {
			type: Array,
			required: false,
			default: () => [],
		},
	},
	methods: {
		onHomePageClick() {
			this.$store.dispatch("trackEvent", {
				eventCategory: "Breadcrumb",
				eventAction: `Click on HP breadcrumb ${this.$t(
					"BreadcrumbWordscapesHomeText"
				)}`,
			});
		},
		onBreadcrumbClick(item) {
			this.$emit("onBreadcrumbClick", item);
		},
	},
};
